import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output } from "@angular/core";
import { AppService } from "@api";
import { HeaderEnum, RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { exportDataGrid } from "devextreme/excel_exporter";
import { ExportingEvent } from "devextreme/ui/data_grid";
import { Workbook } from "exceljs";

@Component(
    {
        selector: 'acuerdopendiente',
        templateUrl: './acuerdopendientedetalle.component.html',
        styleUrls: ['./acuerdopendiente.component.scss']
    })

export class AcuerdoPendienteDetalleComponent implements AfterViewInit{
  consulta!:boolean;
  @Input() entidad!: any;
  @Input() accion!: {accionid: number, accion: string};
  @Output() output = new EventEmitter();

  listaacuerdopendiente: any[] = [];
  resumenPorJefe: { [nombre: string]: { firmados: number, total: number, avance: number } } = {};

  porcentaje: number = 0;

  public animacion!: string;
  public abierto!: boolean;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
      this.getlistaacuerdopendiente();
    }

    acuerdoFirmado(acuerdo: any): boolean {
      return Number(acuerdo?.firmaid) === 1 || acuerdo?.firma === "Firmado";
    }

    calcularResumen() {
      const resumen: { [nombre: string]: { firmados: number, total: number, avance: number } } = {};
      this.listaacuerdopendiente.forEach(acuerdo => {
        const nombre = acuerdo.nombrejefe;
        if (!resumen[nombre]) {
          resumen[nombre] = { firmados: 0, total: 0, avance: 0 };
        }
        resumen[nombre].total++;
        if (this.acuerdoFirmado(acuerdo)) {
          resumen[nombre].firmados++;
        }
      });
      Object.keys(resumen).forEach(nombre => {
        const jefe = resumen[nombre];
        jefe.avance = jefe.total ? Math.trunc((jefe.firmados / jefe.total) * 100) : 0;
      });
      this.resumenPorJefe = resumen;
    }

    resumenJefe(nombre: string) {
      return this.resumenPorJefe[nombre] || { firmados: 0, total: 0, avance: 0 };
    }

    onExporting(e: ExportingEvent) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');
      exportDataGrid({
          component: e.component,
          worksheet: worksheet,
          customizeCell:(options) => {
              options.excelCell.font = { name: 'Arial', size: 12 };
              options.excelCell.alignment = { horizontal: 'left' };
              if (options.gridCell?.rowType === 'group') {
                if(options.excelCell.value !== null){
                  const valor = String(options.excelCell.value);
                  const nombre = valor.replace("Jefe: ", "");
                  const resumen = this.resumenPorJefe[nombre] || this.resumenPorJefe[valor];
                  options.excelCell.font.bold = true;
                  if (resumen) {
                    options.excelCell.value = `${valor} ${resumen.avance}% (${resumen.firmados} de ${resumen.total} terminados)`;
                  }
                }
            }
          }
      }).then(() => {
          workbook.xlsx.writeBuffer()
              .then((buffer: any) => {
                this.exportBlob(buffer, `${this.sistemaService.NombrePantallaActual}.xlsx`);
              });
      });
    }

    getlistaacuerdopendiente(){
      this.appService.Post("acuerdopendiente/buscardetalle", this.entidad).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.listaacuerdopendiente = res.data;
          this.calcularResumen();
        }
      })
    }

    Salir(){
      this.output.next(true);
    }

    envioEmail(){
      const lista = this.listaacuerdopendiente;
      let listaunica: any[] = [];
      lista.forEach(data=>{
       let objeto =  listaunica.findIndex(x=>x.colaboradorjefeid == data.colaboradorjefeid);

       if(objeto >= 0){
        listaunica[objeto]['conteoevaluacion'] = listaunica[objeto]['conteoevaluacion'] + 1;
       }else{
        data["conteoevaluacion"] = 1;
        listaunica.push(data);
       }
      })

      this.appService.Post("acuerdopendiente/enviaremail",{"listacolaborador":listaunica}, [HeaderEnum.NoShowLoading]).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.mensajeService.Alerta(AlertaEnum.Success, res.message);
        }
      })
    }
    private exportBlob(buffer: ArrayBuffer, fileName: string) {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();

      // Libera el objeto URL
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.remove();
      }, 100);
    }
}


